import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const DashboardEstimateReportConfig: ReportConfigBase = {
  type: EReportTypes.DashboardEstimate,
  endpoint: "order",
  reportKey: "orders",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The Dashboard Estimate Report provides detailed information about a rep's estimates",
    url: "https://help.commonsku.com/knowledge/sales-dashboard-report",
  },
};

export default DashboardEstimateReportConfig;
